<template>
<ul class="nav nav-underline" role="tablist">
    <li v-for="tab in tabs" :key="tab.key" class="nav-item">
        <button type="button" role="tab" class="nav-link fw-semibold" :class="active === tab.key ? 'active' : 'text-muted'"
            :aria-selected="active === tab.key" @click="$emit('select', tab.key)">
            {{ tab.label }}
            <span v-if="hasCount(tab)" class="badge rounded-pill" :class="tab.tone === 'danger' ? 'badge-danger' : ''">{{ format(tab.count) }}</span>
        </button>
    </li>
</ul>
</template>

<script>
export default {
    name: 'WnListTabs',
    props: {
        // [{ key, label, count?: number, tone?: 'danger' }] - the badge is shown only when count is a number
        tabs: { type: Array, required: true },
        active: { type: String, default: null },
        // counts above this show as "99+"
        max: { type: Number, default: 99 },
    },
    emits: ['select'],
    methods: {
        hasCount: (tab) => Number.isFinite(tab.count),
        format(count) { return count > this.max ? `${ this.max }+` : count; },
    },
}
</script>
